import { useState } from "#app";

export const useAuthModals = () => {
  // 使用 useState 创建全局响应式状态
  const isSignInModalOpen = useState("isSignInModalOpen", () => false);
  const isSignUpModalOpen = useState("isSignUpModalOpen", () => false);
  // 登录成功后的跳转地址
  const redirectAfterLogin = useState("redirectAfterLogin", () => null);

  // 打开登录弹窗
  const openSignInModal = (redirect = null) => {
    redirectAfterLogin.value = redirect;
    isSignInModalOpen.value = true;
    isSignUpModalOpen.value = false;
  };

  // 打开注册弹窗
  const openSignUpModal = (redirect = null) => {
    redirectAfterLogin.value = redirect;
    isSignUpModalOpen.value = true;
    isSignInModalOpen.value = false;
  };

  // 关闭所有弹窗
  const closeAuthModals = () => {
    isSignInModalOpen.value = false;
    isSignUpModalOpen.value = false;
  };

  // 关闭登录弹窗
  const closeSignInModal = () => {
    isSignInModalOpen.value = false;
  };

  // 关闭注册弹窗
  const closeSignUpModal = () => {
    isSignUpModalOpen.value = false;
  };

  // 清除跳转地址
  const clearRedirect = () => {
    redirectAfterLogin.value = null;
  };

  // 获取并清除跳转地址
  const consumeRedirect = () => {
    const redirect = redirectAfterLogin.value;
    redirectAfterLogin.value = null;
    return redirect;
  };

  // 在登录和注册之间切换
  const switchToSignUp = () => {
    isSignInModalOpen.value = false;
    isSignUpModalOpen.value = true;
  };

  const switchToSignIn = () => {
    isSignUpModalOpen.value = false;
    isSignInModalOpen.value = true;
  };

  return {
    isSignInModalOpen,
    isSignUpModalOpen,
    redirectAfterLogin,
    openSignInModal,
    openSignUpModal,
    closeAuthModals,
    closeSignInModal,
    closeSignUpModal,
    clearRedirect,
    consumeRedirect,
    switchToSignUp,
    switchToSignIn,
  };
};
